export default __webpack_public_path__ + "static/media/stcpgraph.b960a599.jpg";